import React, { useRef, useEffect, useState } from 'react'

import clsx from 'clsx'

import CompareBasket from 'components/CompareBasket'
import { useCompareBasket } from 'context/CompareBasketContext'

import { getCurrentTranslation } from './helpers'

import classes from './CompareBasketMobile.module.scss'

const INITIAL_VISIBLE = 72

const CompareBasketMobile = () => {
  const swipeRef = useRef()
  const compareBasket = useCompareBasket()
  const [initialized, setInitialized] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [swiping, setSwiping] = useState({
    enabled: false,
    initialX: null,
    initialY: null,
    currentTranslation: 0,
  })

  useEffect(() => {
    if (!initialized || !swipeRef.current) return
    if (!initialized && swipeRef.current) {
      setSwiping(data => ({
        ...data,
        currentTranslation: compareBasket.items.length ? 0 : swipeRef?.current?.scrollHeight - INITIAL_VISIBLE,
      }))
      setInitialized(true)
      return
    }
    setSwiping(data => ({ ...data, currentTranslation: 0 }))
  }, [compareBasket.items.length, initialized])

  const enableScroll = () => {
    document.body.style.overflow = 'initial'
  }

  const disableScroll = () => {
    document.body.style.overflow = 'hidden'
  }

  const canPerformSwipe = translation => {
    const isSwipeUp = translation < 0
    if (dialogOpen) return false
    if (isSwipeUp && swiping.currentTranslation === 0) return false
    if (!isSwipeUp && swiping.currentTranslation === swipeRef?.current?.scrollHeight - INITIAL_VISIBLE) return false
    return true
  }

  const onTouchStart = e => {
    disableScroll()
    const { clientX, clientY } = e.targetTouches[0]
    setSwiping(data => ({ ...data, enabled: true, initialY: clientY, initialX: clientX }))
  }

  const onTouchMove = e => {
    // get the translated distance
    // translate the element with the translated distance
    // prevent translating more than the element height
    const { clientY } = e.targetTouches[0]
    const diffTranslateY = clientY - swiping.initialY
    if (!swiping.enabled || !canPerformSwipe(diffTranslateY)) {
      return
    }

    const elementHeight = swipeRef?.current?.scrollHeight

    let currentTranslation = getCurrentTranslation(elementHeight, diffTranslateY)

    setSwiping(data => ({ ...data, currentTranslation }))
  }

  const onTouchEnd = e => {
    const { clientY } = e.changedTouches[0]
    const diffTranslateY = clientY - swiping.initialY
    const isSwipeUp = diffTranslateY < 0
    setSwiping(data => ({ ...data, enabled: false }))

    if (!canPerformSwipe(diffTranslateY)) {
      enableScroll()
      return
    }

    const translationOpened = 0
    const translationClosed = swipeRef?.current?.scrollHeight - INITIAL_VISIBLE

    const minSwipeBounding = swipeRef?.current?.scrollHeight / 4
    const absYDiff = Math.abs(diffTranslateY)

    if (absYDiff < minSwipeBounding) {
      const currentTranslation = !isSwipeUp ? translationOpened : translationClosed
      setSwiping(data => ({ ...data, currentTranslation }))
    } else {
      if (!isSwipeUp) {
        setSwiping(data => ({ ...data, currentTranslation: translationClosed }))
      } else {
        setSwiping(data => ({ ...data, currentTranslation: translationOpened }))
      }
    }
    enableScroll()
  }

  return (
    <>
      {compareBasket.items.length > 0 && (
        <div
          ref={swipeRef}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          className={clsx('CompareBasketMobile', classes.root)}
          style={{ transform: `translate3d(0, ${swiping.currentTranslation}px, 0)` }}
          data-testid="mobile_compare-basket_button"
        >
          <CompareBasket dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
        </div>
      )}
    </>
  )
}

export default CompareBasketMobile
